import {
  GET_PENDING_DETAIL,
  GET_PENDING_DETAIL_SUCCESS,
  GET_PENDING_DETAIL_FAILURE,
} from 'store/createPendingDetail/createPendingDetailAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const postPendingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PENDING_DETAIL:
      return { ...state, loading: true };
    case GET_PENDING_DETAIL_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PENDING_DETAIL_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default postPendingReducer;
